import {InputLabel, Stack, TextField, Checkbox, FormControlLabel} from "@mui/material";
import Button from "@mui/material/Button";
import {RestartAlt, Search} from "@mui/icons-material";
import * as React from "react";
import {useSearchParams} from "react-router-dom";
import Grid from "@mui/material/Grid";
import {Fragment, useEffect, useState} from "react";
import helpers from "../../helpers/common";
import moment from 'moment'
import {LocalizationProvider} from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DateTimePicker} from '@mui/x-date-pickers/DateTimePicker';
import {FormControl, MenuItem, Select} from "@mui/material";
import projects from "../../models/projects";
import merchants from "../../models/merchants";

const DATE_FORMAT = 'DD/MM/YYYY HH:mm'
export default function ActionLogsFilter() {
    const [searchParams, setSearchParams] = useSearchParams()
    const [fields, setFields] = useState({})
    const [projectsData, setProjectsData] = useState([])
    const [merchantsData, setMerchantsData] = useState([])

    useEffect(() => {
        // Load projects and merchants for filters
        projects.index().then((data) => {
            if (data && data.projects) {
                setProjectsData(data.projects)
            }
        }).catch(() => {})
        
        merchants.list().then((data) => {
            if (data && data.merchants) {
                setMerchantsData(data.merchants)
            }
        }).catch(() => {})

        setFields({
            search: searchParams.get('search') || '',
            project_id: searchParams.get('project_id') || '',
            merchant_id: searchParams.get('merchant_id') || '',
            limit_exceeded: searchParams.get('limit_exceeded') === 'true',
            action_type: searchParams.get('action_type') || 'all',
            created_from: searchParams.get('created_from') || undefined,
            created_to: searchParams.get('created_to') || undefined
        })
    }, [searchParams])

    const handleSearch = (ev) => {
        ev.preventDefault()
        Object.keys(fields).forEach((key) => {
            if (key === 'limit_exceeded') {
                if (fields[key]) {
                    searchParams.set(key, 'true')
                } else {
                    searchParams.delete(key)
                }
                return
            }
            if (!fields[key]) {
                searchParams.delete(key)
                return
            }
            searchParams.set(key, fields[key].toString())
        })
        setSearchParams(searchParams)
    }

    const handleChange = (ev) => {
        const [target, value, name] = helpers.getFormEventData(ev);

        setFields((prevState) => {
            let newFields = {...prevState}
            newFields[name] = value

            return newFields
        })
    }

    const handleCheckboxChange = (ev) => {
        setFields((prevState) => {
            let newFields = {...prevState}
            newFields[ev.target.name] = ev.target.checked
            return newFields
        })
    }

    return <Fragment>
        <Grid container spacing={2}
                     component="form"
                     onSubmit={handleSearch}
                     noValidate
                     autoComplete="off"
        >
            <Grid size={{ xs: 12, md: 6 }}>
                <InputLabel>Поиск (UUID, External ID, Provider ID...)</InputLabel>
                <TextField
                    value={fields.search || ''}
                    id="search"
                    name="search"
                    size="small"
                    fullWidth={true}
                    onChange={handleChange}
                    placeholder="Поиск по UUID, External ID, Provider ID, email..."
                />
            </Grid>
            <Grid size={{ xs: 12, md: 3 }}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={fields.limit_exceeded || false}
                            onChange={handleCheckboxChange}
                            name="limit_exceeded"
                        />
                    }
                    label="Только с превышением лимита"
                />
            </Grid>
            <Grid size={{ xs: 12, md: 3 }}>
                <InputLabel>Тип записи</InputLabel>
                <FormControl fullWidth size="small">
                    <Select
                        value={fields.action_type || 'all'}
                        name="action_type"
                        id="action_type"
                        onChange={handleChange}
                    >
                        <MenuItem value="all"><em>Все</em></MenuItem>
                        <MenuItem value="transaction">Transactions</MenuItem>
                        <MenuItem value="error">Errors</MenuItem>
                    </Select>
                </FormControl>
            </Grid>
            <Grid size={{ xs: 12, md: 3 }}>
                <InputLabel>Проект</InputLabel>
                <FormControl fullWidth size="small">
                    <Select
                        value={fields.project_id || ''}
                        name="project_id"
                        id="project_id"
                        onChange={handleChange}
                    >
                        <MenuItem value=""><em>Все проекты</em></MenuItem>
                        {projectsData.map((project) => (
                            <MenuItem key={`project-${project.id}`} value={project.id}>
                                {project.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
            <Grid size={{ xs: 12, md: 3 }}>
                <InputLabel>Мерчант</InputLabel>
                <FormControl fullWidth size="small">
                    <Select
                        value={fields.merchant_id || ''}
                        name="merchant_id"
                        id="merchant_id"
                        onChange={handleChange}
                    >
                        <MenuItem value=""><em>Все мерчанты</em></MenuItem>
                        {merchantsData.map((merchant) => (
                            <MenuItem key={`merchant-${merchant.id}`} value={merchant.id}>
                                {merchant.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
            <Grid size={{ xs: 12, md: 3 }}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DateTimePicker
                        label="Дата от"
                        disableFuture={true}
                        value={moment.utc(fields.created_from)}
                        ampm={false}
                        inputFormat={DATE_FORMAT}
                        onChange={(newValue) => {
                            setFields((prevState) => {
                                let newFields = {...prevState}
                                newFields.created_from = newValue ? newValue.set({second: 0, millisecond: 0}).toISOString() : undefined
                                return newFields
                            })
                        }}
                        renderInput={(params) => <TextField fullWidth={true} size="small" {...params} />}
                    />
                </LocalizationProvider>
            </Grid>
            <Grid size={{ xs: 12, md: 3 }}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DateTimePicker
                        label="Дата до"
                        value={moment.utc(fields.created_to)}
                        ampm={false}
                        inputFormat={DATE_FORMAT}
                        onChange={(newValue) => {
                            setFields((prevState) => {
                                let newFields = {...prevState}
                                newFields.created_to = newValue ? newValue.set({second: 59, millisecond: 999}).toISOString() : undefined
                                return newFields
                            })
                        }}
                        renderInput={(params) => <TextField fullWidth={true} size="small" {...params} />}
                    />
                </LocalizationProvider>
            </Grid>
            <Grid size={12}>
                <Stack spacing={2} direction="row">
                    <Button type="submit" variant="outlined" startIcon={<Search />}>
                        Поиск
                    </Button>
                    <Button onClick={() => {
                        setFields({
                            search: '',
                            project_id: '',
                            merchant_id: '',
                            action_type: 'all',
                            limit_exceeded: false,
                            created_from: undefined,
                            created_to: undefined
                        });
                        setSearchParams({})
                    }} variant="outlined" color="secondary" startIcon={<RestartAlt />}>
                        Сбросить
                    </Button>
                </Stack>
            </Grid>
        </Grid>
    </Fragment>
}

